module.exports = __webpack_public_path__ + "static/img/cefta.dcb94060.svg";